import React from 'react';
import { stats } from '../mock';

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="section-container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-value">
                {stat.currency && <span className="stat-currency">{stat.currency}</span>}
                {stat.value}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;